import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getCheckoutOutboundRatesSettings = {
  name: "getCheckoutOutboundRatesSettings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    enabled: z.boolean(),
    demoEnabled: z.boolean(),
    hideNonRedoRatesWhenRedoPresent: z.boolean(),
    customCarrierServiceName: z.string().optional(),
    subscriptionsModeEnabled: z.boolean(),
    preventSplitShipmentsRateAddition: z.boolean(),
    useShippingOptionMetafields: z.boolean(),
  }),
};
